var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { jsx as _jsx } from "react/jsx-runtime";
import { SmileOutlined } from "@ant-design/icons";
import * as Ant from "antd";
import { XForm } from "@bluelibs/x-ui-admin";
import { Routes } from "@bundles/UIAppBundle";
import { Service, Inject } from "@bluelibs/core";
import { features } from "./features";
import { UsersCollection, CompaniesCollection, } from "@bundles/UIAppBundle/collections";
let CompanyCreateForm = class CompanyCreateForm extends XForm {
    build() {
        const { UIComponents } = this;
        const { t } = this.i18n;
        this.add([
            {
                id: "name",
                label: t("management.companies.fields.name"),
                name: ["name"],
                required: true,
                component: Ant.Input,
            },
            {
                id: "email",
                label: t("management.companies.fields.email"),
                name: ["email"],
                required: true,
                component: Ant.Input,
            },
            {
                id: "phone",
                label: t("management.companies.fields.phone"),
                name: ["phone"],
                required: true,
                component: Ant.Input,
            },
            {
                id: "address",
                label: t("management.companies.fields.address"),
                name: ["address"],
                required: true,
                component: Ant.Input,
            },
            {
                id: "city",
                label: t("management.companies.fields.city"),
                name: ["city"],
                required: true,
                component: Ant.Input,
            },
            {
                id: "state",
                label: t("management.companies.fields.state"),
                name: ["state"],
                required: true,
                component: Ant.Input,
            },
            {
                id: "zip",
                label: t("management.companies.fields.zip"),
                name: ["zip"],
                required: true,
                component: Ant.Input,
            },
            {
                id: "country",
                label: t("management.companies.fields.country"),
                name: ["country"],
                required: true,
                component: Ant.Input,
            },
            {
                id: "website",
                label: t("management.companies.fields.website"),
                name: ["website"],
                required: true,
                component: Ant.Input,
            },
            {
                id: "allowedUsersIds",
                label: t("management.companies.fields.allowedUsers"),
                name: ["allowedUsersIds"],
                required: true,
                render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(UIComponents.RemoteSelect, { collectionClass: UsersCollection, field: "fullName", required: true, mode: "multiple" }, void 0) }), void 0)),
            },
        ]);
    }
    onSubmit(document, cb) {
        const { t } = this.i18n;
        return this.collection
            .insertOne(document)
            .then(({ _id, name }) => {
            Ant.notification.success({
                message: t("generics.success"),
                description: t("management.companies.create_confirmation"),
                icon: _jsx(SmileOutlined, {}, void 0),
            });
            if (cb) {
                cb({ _id, name });
            }
            else {
                if (features.view) {
                    return this.router.go(Routes.COMPANIES_VIEW, {
                        params: {
                            id: _id,
                        },
                    });
                }
                if (features.list) {
                    return this.router.go(Routes.COMPANIES_LIST);
                }
                if (features.edit) {
                    return this.router.go(Routes.COMPANIES_EDIT, {
                        params: {
                            id: _id,
                        },
                    });
                }
            }
        })
            .catch((err) => {
            Ant.notification.warn({
                message: t("generics.error"),
                description: t("generics.error_message"),
            });
        });
    }
};
__decorate([
    Inject(() => CompaniesCollection),
    __metadata("design:type", typeof (_a = typeof CompaniesCollection !== "undefined" && CompaniesCollection) === "function" ? _a : Object)
], CompanyCreateForm.prototype, "collection", void 0);
CompanyCreateForm = __decorate([
    Service({ transient: true })
], CompanyCreateForm);
export { CompanyCreateForm };
